var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    {
      attrs: {
        disabled: _vm.disabled,
        readonly: _vm.readonly,
        type: _vm.type,
        rows: _vm.rows,
        size: _vm.size,
        placeholder: _vm.placeholder || _vm.$t("inputText"),
        maxlength: _vm.maxlength,
        clearable: "",
        "show-word-limit": _vm.showWordLimit,
      },
      on: {
        focus: _vm.onFocus,
        blur: function ($event) {
          _vm.id = $event.target.value.trim()
        },
        change: _vm.onChange,
      },
      nativeOn: {
        keyup: function ($event) {
          return _vm.onKeyUp.apply(null, arguments)
        },
      },
      model: {
        value: _vm.id,
        callback: function ($$v) {
          _vm.id = $$v
        },
        expression: "id",
      },
    },
    [_c("template", { slot: "append" }, [_vm._t("append")], 2)],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }